/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc2Inputs */

const en_fc_tut_sc2 = /** @type {(inputs: Fc_Tut_Sc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite edit`)
};

/**
* | output |
* | --- |
* | "Overwrite edit" |
*
* @param {Fc_Tut_Sc2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc2 = /** @type {((inputs?: Fc_Tut_Sc2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc2(inputs)
});
export { fc_tut_sc2 as "fc.tut.sc2" }